module.exports = __webpack_public_path__ + "static/media/logo.a6adee99.svg";